import { useMemo } from "react";

import type {
  PinnedVersionSelectorLabel,
  PinnedVersionSelectorVersion,
} from "@/components/SharedSessions";
import { useListSkillCollectionVersions } from "@/queries/skill-collections";

export const useSkillSharePinnedVersionData = (
  workspaceId: number,
  collectionId: string,
): {
  versions: PinnedVersionSelectorVersion[];
  labels: PinnedVersionSelectorLabel[];
} => {
  const { data } = useListSkillCollectionVersions(workspaceId, collectionId);

  const rawVersions = useMemo(
    () => data?.pages.flatMap(page => page.versions) ?? [],
    [data?.pages],
  );

  return useMemo(() => {
    const versions = rawVersions.map(v => ({ number: v.number }));
    const labels: PinnedVersionSelectorLabel[] = rawVersions.flatMap(version =>
      (version.labels ?? []).map(label => ({
        id: label.id,
        name: label.name,
        versionNumber: version.number,
      })),
    );

    return { versions, labels };
  }, [rawVersions]);
};
